import _defineProperty from '../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import _toConsumableArray from '../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js';
import { curry, nth, isNil, last, init } from 'ramda';
import '../utils/createTimeline.js';
import '../utils/convertAxisListToTiles.js';
import '../utils/convertAxisToTile.js';
import '../utils/parseCode.js';
import '../utils/detectDarkTile.js';
import '../utils/detectPiece.js';
import '../utils/detectOpponent.js';
import '../utils/detectMoved.js';
import '../utils/detectEnemyOnTiles.js';
import '../utils/detectTurn.js';
import '../utils/detectContacted.js';
import '../utils/findCode.js';
import '../utils/findCodeByTile.js';
import '../utils/findOpponentKing.js';
import '../utils/getNextFileByIndex.js';
import '../utils/getNextRankByIndex.js';
import '../utils/getPKeyByTile.js';
import '../utils/getEqualPieces.js';
import '../utils/getSymmetryTile.js';
import '../utils/getAnimationAxis.js';
import '../utils/getDirection.js';
import '../utils/getTilesDifference.js';
import '../utils/removeDirection.js';
import '../utils/removeCodeByTile.js';
import '../utils/replaceCode.js';
import '../presets/rules.js';
import '../utils/validateTile.js';
import '../utils/filterOpponent.js';
import '../utils/computeDistance.js';
import '../utils/pretendTo.js';
import '../utils/transformInto.js';
import diffSnapshot from '../utils/diffSnapshot.js';
import '../utils/subInBetweenIndexes.js';

function ownKeys(e,r){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);r&&(o=o.filter((function(r){return Object.getOwnPropertyDescriptor(e,r).enumerable}))),t.push.apply(t,o);}return t}function _objectSpread(e){for(var r=1;r<arguments.length;r++){var t=null!=arguments[r]?arguments[r]:{};r%2?ownKeys(Object(t),!0).forEach((function(r){_defineProperty(e,r,t[r]);})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):ownKeys(Object(t)).forEach((function(r){Object.defineProperty(e,r,Object.getOwnPropertyDescriptor(t,r));}));}return e}function createSheetData(e,r){return [].concat(_toConsumableArray(r),[e]).reduce((function(e,r,t,o){var n=nth(t+1,o);if(isNil(n))return e;var a=diffSnapshot(r.snapshot,n.snapshot),c=a.from,i=a.to,p=_defineProperty({},r.turn,{checkData:n.checkData,from:c,to:i});return (last(e)||{}).black?[].concat(_toConsumableArray(e),[p]):[].concat(_toConsumableArray(init(e)),[_objectSpread(_objectSpread({},last(e)),p)])}),[])}var createSheetData$1 = curry(createSheetData);

export { createSheetData$1 as default };
//# sourceMappingURL=createSheetData.js.map
